import { Container } from 'react-bootstrap';
import { Trans } from 'react-i18next';

import useUiTranslation from 'src/hooks/useUiTranslation';

const ErrorBoundaryPage = () => {
  const { tPages } = useUiTranslation();
  return (
    <Container className="h-100 d-flex justify-content-center align-items-center">
      <div className="text-center">
        <h1>{tPages('errorBoundary.unexpectedError')}</h1>

        <p>{tPages('errorBoundary.applicationRestart')}</p>

        <p>
          <Trans
            i18nKey="ui.pages.errorBoundary.problemPersistContact"
            components={{
              a: <a href="mailto:service@optainhealth.com">get in touch</a>,
            }}
          />
        </p>
      </div>
    </Container>
  );
};

export default ErrorBoundaryPage;
